import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { add_batch_loading : true, add_batch: '', add_batch_error: false};

export function addBatch(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ADD_BATCH_ORG:
        return {
            add_batch_loading: true,
            add_batch: '',
            add_batch_error: false
        };
      case organisationConstants.RECIEVE_ADD_BATCH_ORG:
        return {
            add_batch_loading: false,
            add_batch: action.add_batch,
            add_batch_error: false
        };
      case organisationConstants.ERROR_ADD_BATCH_ORG:
        return { 
            batch_list_loading: false,
            add_batch: '',
            add_batch_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/addBatchOrg.reducer.js